import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getProducts = (category) =>
    axios
        .get(`${API}/products`, { params: category ? { category } : {} })
        .then((r) => r.data);

export const getProduct = (slug) =>
    axios.get(`${API}/products/${slug}`).then((r) => r.data);

export const getFarms = () => axios.get(`${API}/farms`).then((r) => r.data);

export const getFarm = (id) => axios.get(`${API}/farms/${id}`).then((r) => r.data);

export const getReviews = () => axios.get(`${API}/reviews`).then((r) => r.data);

export const getJournal = () => axios.get(`${API}/journal`).then((r) => r.data);

export const getJournalPost = (slug) =>
    axios.get(`${API}/journal/${slug}`).then((r) => r.data);

export const createOrder = (payload) =>
    axios.post(`${API}/orders`, payload).then((r) => r.data);

export const getOrder = (id) => axios.get(`${API}/orders/${id}`).then((r) => r.data);

export const subscribeNewsletter = (email) =>
    axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

export const getClubPlans = () => axios.get(`${API}/club/plans`).then((r) => r.data);

export const clubSubscribe = (payload) =>
    axios.post(`${API}/club/subscribe`, payload).then((r) => r.data);

export const formatPrice = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);

// Multi-buy incentive — must mirror backend logic (cuts only)
export const multibuyRate = (category, quantity) => {
    if (category === "cut") {
        if (quantity >= 6) return 0.1;
        if (quantity >= 3) return 0.05;
    }
    return 0;
};

export const discountedLineTotal = (item) => {
    const gross = item.price * item.quantity;
    return gross - gross * multibuyRate(item.category, item.quantity);
};
